import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 152 152"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M76 12.667C41.04 12.667 12.667 41.04 12.667 76S41.04 139.333 76 139.333 139.333 110.96 139.333 76 110.96 12.667 76 12.667m-12.667 95L31.667 76l8.93-8.93 22.736 22.673 48.07-48.07 8.93 8.993z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }